/* @flow */

export const __DEV__ = false;
export const idRegex = /^([a-z0-9_])+$/;
export const hasEditor = process.env.REACT_APP_HAS_EDITOR === 'true';
export const enableHelperLogger = true;
